import {Col, Row, Space, Typography} from "@bezlimit/bezlimit-ui";
import {notification} from "antd";
import {
    EmailShareButton,
    VKShareButton,
    WhatsappShareButton,
    ViberShareButton,
    TelegramShareButton
} from "react-share";
import _ from "lodash";
import {observer} from "mobx-react";
import {useContext} from "react";
import {useTranslation} from "react-i18next";
import "./style.scss";
import emalShare from "../../../images/emalShare.png";
import vkShare from "../../../images/vkShare.png";
import whatsappShare from "../../../images/whatsappShare.png";
import viberShare from "../../../images/viberShare.png";
import telegramShare from "../../../images/telegramShare.png";
import copyShare from "../../../images/copyShare.png";
import Success from "../../../images/success.png";
// core
import {LayoutContext, ModalContext} from "../../../core/Contexts";
import UserService from "../../../services/UserService";
import {IReservationsPhoneDocs} from "../../../core/models/Reservations";

const ShareDocScontractkModal = observer(({docContract}: IProps) => {
    const {t} = useTranslation();
    const contextLayout = useContext(LayoutContext);
    const contextModal = useContext(ModalContext);

    const onClick = () => {
        navigator.clipboard.writeText(docContract[0]?.link).then(() => {
            notification.open({
                message: "",
                placement: !_.gte(contextLayout?.width ?? 0, 568) ? "top" : "topRight",
                closeIcon: undefined,
                icon: <img src={Success} width={34} alt="superLink" />,
                className: "copy-referral-delivery",
                description: "Ссылка скопирована в буфер обмена",
                duration: 2
            });
        });
        contextModal?.setCssClass("");
        contextModal?.setVisible(false);
    };

    return (
        <Typography as="div" className="bl-share-super-limk-modal">
            <Space
                size={_.gte(contextLayout?.width ?? 0, 768) ? 24 : 16}
                direction="vertical"
                align="center"
            >
                <Typography as="div" color="#1F1F1F" size={17} className="title">
                    {t("Поделиться ссылкой")}
                </Typography>
                <Row gutter={[16, 31]}>
                    <Col sm={6} xs={12}>
                        <Typography as="div" onClick={onClick} className="copy-btn">
                            <img src={copyShare} alt="" />
                            <Typography as="div" color="#1F1F1F" size={12}>
                                {t("Скопировать")}
                            </Typography>
                        </Typography>
                    </Col>
                    <Col sm={6} xs={12}>
                        <EmailShareButton url={docContract[0]?.link}>
                            <img src={emalShare} alt="" />
                            <Typography as="div" color="#1F1F1F" size={12}>
                                {t("Отправить на почту")}
                            </Typography>
                        </EmailShareButton>
                    </Col>
                    <Col sm={6} xs={12}>
                        <WhatsappShareButton url={docContract[0]?.link}>
                            <img src={whatsappShare} alt="" />
                            <Typography as="div" color="#1F1F1F" size={12}>
                                {t("WhatsApp")}
                            </Typography>
                        </WhatsappShareButton>
                    </Col>
                    <Col sm={6} xs={12}>
                        <TelegramShareButton url={docContract[0]?.link}>
                            <img src={telegramShare} alt="" />
                            <Typography as="div" color="#1F1F1F" size={12}>
                                {t("Telegram")}
                            </Typography>
                        </TelegramShareButton>
                    </Col>
                </Row>
            </Space>
        </Typography>
    );
});
export default ShareDocScontractkModal;

interface IProps {
    docContract: IReservationsPhoneDocs[];
}
